import type { Disposable } from './Disposable.js';

export type AutoDispose = <T extends Disposable>(item: T) => T;
